const HomePage = () => {
  return <div>Welcome to the Skin Seoul</div>;
};

export default HomePage;
